import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconLineDown = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} defaultColorKey="statusNegative" {...props}>
      <Path fill={`url(#gradient_${id})`} fillRule="evenodd" d="M21.988 16.998v-4.01a1 1 0 0 0-1.707-.707l-1.293 1.293-5.293-5.293a1 1 0 0 0-1.414 0l-3.293 3.293L3.695 6.28A1 1 0 0 0 2.28 7.695l6 6a1 1 0 0 0 1.414 0l3.293-3.293 4.586 4.586-1.293 1.293a1 1 0 0 0 .707 1.707h4l.048-.001a.996.996 0 0 0 .952-.99" clipRule="evenodd"/>
    </IconWithGradient>);
};
export default IconLineDown;
